<bn-loading-overlay></bn-loading-overlay>
<div class="container" *ngIf="atributosPaginacao.list">
    <form #formPriorizacao="ngForm" >
    <p>Repriorize as solicitações de honra utilizando as ações
        <span class="fa fa-arrow-up" ngbTooltip="aumenta a prioridade de uma solicitação"></span> e 
        <span class="fa fa-arrow-down" ngbTooltip="reduz a prioridade de uma solicitação"></span>, ou 
        informando diretamente a prioridade desejada através do campo <strong>Prioridade nova</strong>.
    </p>
    <bn-paginacao [total]="atributosPaginacao.count" id="bnPaginacao"
        [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
        [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
    <div class="table-responsive" >
        <table class="table table-hover table-sm">
        <thead>
            <th id="col-idOperacaoExterno" scope="col">
                Identificação
                <i class="fa fa-question-circle help-subtitulo" placement="bottom" 
                    ngbTooltip="Identificador da operação de Crédito Livre ou Sistema/Número do contrato constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </th>
            <th id="col-dataParcelaInicialASerHonrada" scope="col">
                1&ordf; parcela honrada
            </th>
            <th id="col-valorEstimadoHonra" scope="col" class="text-end">
                Valor estimado
            </th>
            <th id="col-prioridadeOri" scope="col" >
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'prioridadeOriginal'"
                    [nomeAtributoExibicao]="'Prioridade original'"(aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
            </th>                        
            <th id="col-prioridadeNova" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'prioridadeNova'"
                    [nomeAtributoExibicao]="'Prioridade nova'"(aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
            </th>             
            <th scope="col" class="text-center">ações</th> 
        </thead>
        <tbody>
            <tr *ngFor="let solicitacaoHonra of atributosPaginacao.list; let i = index">
                <td>{{ solicitacaoHonra.contratoRepasse ? solicitacaoHonra.sistemaRepasse + '/' + solicitacaoHonra.contratoRepasse : solicitacaoHonra.idOperacaoExterno}}</td>
                <td>{{ solicitacaoHonra.dataParcelaInicialASerHonrada ? (solicitacaoHonra.dataParcelaInicialASerHonrada | date: 'dd/MM/yyyy') : 'N.A.'}}</td>
                <td class="text-end">{{ solicitacaoHonra.valorEstimadoHonra | bnMask: 'MOEDA'}}</td>
                <td class="text-center">{{ solicitacaoHonra.prioridadeOriginal}}</td>
                <td><input [(ngModel)]="solicitacaoHonra.prioridadeNova" class="form-control" name="prioridadeNova_{{i}}" maxlength="4" size="4"></td>
                <td class="text-center">
                    <a href="javascript:void(0)" (click)="aumentar(i)">
                        <i aria-hidden="true" placement="left-top" class="fa fa-arrow-up" > </i></a>
                    <a href="javascript:void(0)" (click)="reduzir(i)">
                        <i aria-hidden="true" placement="left-top" class="fa fa-arrow-down margin-left-5"></i></a>
                </td>
            </tr>
        </tbody>
        </table>
    </div>
    </bn-paginacao>
    </form>
</div>
<div class="container " *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
        <table class="table table-bordered">    
            <thead>
                <tr>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrencias">
                    <td>{{ ocorrencia.mensagem }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>    
<div class="container " *ngIf="ocorrenciasCadastroSH?.length > 0">
    <div class="table-responsive">
        <table class="table-striped table-bordered">
            <thead>
                <tr>
                    <th class="text-center">
                        Identificador
                      </th>
                    <th class="text-center">Erro(s) encontrado(s)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ocorrencia of ocorrenciasCadastroSH">
                    <td width="20%">
                        {{ ocorrencia.idObjetoValidado }}
                    </td>
                    <td width="80%">
                        {{ ocorrencia.mensagem }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>